export default "__VITE_ASSET__BzciyNr$__"